// Allow Hot Module Replacement (HMR) for JS files
// For more details see https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}

import './select.scss';

document.querySelectorAll('.select-input').forEach((wrapper) => {
  const field = wrapper.querySelector('.select-input__field');
  const trailingIcon = wrapper.querySelector('.select-input__icon--trailing');

  if (!(field instanceof HTMLSelectElement) || !trailingIcon) {
    return;
  }

  trailingIcon.addEventListener('click', (event) => {
    if (field.disabled) {
      return;
    }

    event.preventDefault();
    field.focus();

    if (typeof field.showPicker === 'function') {
      field.showPicker();
      return;
    }

    field.click();
  });
});
